// extracted by mini-css-extract-plugin
export default {"card":"Y0-z","carouselContainer":"Z0-z","carouselContent":"_0-z"};